import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import _ from "lodash";
import { Form, Segment, Button, TextArea, Table, Tab } from "semantic-ui-react";
import FormErrorMessage from "../../utils/FormErrorMessage";
import { createFullOrder, 
    updateOrderModelInStore,
    addLineToUnsavedModel,
    addLineToSavedModel,
    updateCompleteOrder
} from "../../../actions/order";
import { loadRelationById } from "../../../actions/relation";
import Dls from "../../../lib";
import RelationSearch from '../../utils/searches/RelationSearch';
import AddressSelector from '../../utils/searches/AddressSelector';
import InventorySearch from '../../utils/searches/InventorySearch';
import OrderLineForm from './OrderLine';

class OrderForm extends Component {
    constructor() {
        super();
        this.state = {
            errors: [],
            loading: false,
            startDate: ''
        };
    }

    componentDidMount() {
        const {model, jwt} = this.props;
        if (model.relation_id) {
            this.props.loadRelationById(jwt, model.relation_id);
        }
    }

    onFormSubmit = () => {
        const errors = this.validateInput();
        const action = this.props.model.id ? "Update" : "Create";
        if (_.isEmpty(errors)) {
            this.setState({
                loading: true
            });

            if (action === "Create") {
                this.props.createFullOrder(this.props.jwt, this.props.model).then(res => {
                    this.props.history.push(`/${this.props.routeType}/${res.data.data.id}/view`);
                }).catch(err => {
                    const errors = Dls.apiErrorMessage(err);
                    this.setState({
                        loading: false,
                        errors: errors
                    });
                });
            } else {
                this.props.updateCompleteOrder(this.props.jwt, this.props.model).then( res => {
                    this.props.history.push(`/${this.props.routeType}/${this.props.model.id}/view`);
                }).catch( err => {
                    const errors = Dls.apiErrorMessage(err);
                    this.setState({
                        loading: false,
                        errors: errors
                    });
                })
            }
        } else {
            this.setState({
                errors: errors
            });
        }
    };

    validateInput = () => {
        const { reference, warehouse_id, relation_id, currency, 
            lines_view, term_id, tax_id } = this.props.model;
        const errors = [];
        if (_.isEmpty(lines_view)) {
            errors.push("Please add at least one inventory line");
        }
        if (currency.length !== 3) {
            errors.push("Currency code must be 3 characters");
        }
        if (parseInt(relation_id <= 0)) {
            errors.push("A relation (customer or vendor) must be selected");
        }
        if (parseInt(warehouse_id <= 0)) {
            errors.push("A default warehouse must be selected");
        }
        if (!tax_id) {
            errors.push("Tax is required");
        }
        return errors;
    };

    onRelationSearchChange = (e, {value}) => {
        //1. Value is customer or vendor ID

        //2. Go to server, get this customer or vendor
        const {jwt, updateOrderModelInStore, user, warehouses} = this.props;
        this.props.loadRelationById(jwt, value).then( res => {
            const relation = res.data.data;
            updateOrderModelInStore('relation_id', _.toString(relation.id));
            updateOrderModelInStore('term_id', relation.term_id);
            updateOrderModelInStore('tax_id', relation.tax_id);
            updateOrderModelInStore('currency', relation.currency);
            const {addresses, contacts} = relation;
            if (addresses.length > 0) {
                updateOrderModelInStore('bill_to', _.toString(addresses[0].id));
                updateOrderModelInStore('ship_to', _.toString(addresses[0].id));
            }
            if (contacts.length > 0) {
                updateOrderModelInStore('contact_id', _.toString(contacts[0].id));
            }
            updateOrderModelInStore('assigned_to', _.toString(user.id));
            if (warehouses.length > 0) {
                updateOrderModelInStore('warehouse_id', _.toString(warehouses[0].value));
            }
        }).catch(err => {

        })
    }

    onChildSelectorValueChange = (e, {value}, field) => {
        this.props.updateOrderModelInStore(field, value);
    }

    onInventorySelected = (inventory) => {
        const {model, jwt} = this.props;
        const {lines_view,type} = model;
        let canAddNewLine = true;
        _.each(lines_view, line => {
            if (_.toInteger(line.inventory_id) === _.toInteger(inventory.id)) {
                canAddNewLine = false;
            }
        });
        
        if (canAddNewLine) {
            if (model.id) {
                //Add new line to an existing PO
                this.props.addLineToSavedModel(jwt, inventory, type, model.id);
            } else {
                //Add new line to an existing model
                this.props.addLineToUnsavedModel(inventory, type);
            }
        }
    }

    exceptedInventoryIds = () => {
        const {lines_view} = this.props.model;
        const except = [];
        if (_.isArray(lines_view)) {
            _.each(lines_view, line => {
                if(_.isObject(line)) {
                    except.push(line.inventory_id);
                }
            });
        }
        return except;
    }
    
    render() {
        const {model, updateOrderModelInStore, isDirty, warehouses, taxes, terms, users, addresses, contacts, routeType} = this.props;
        const poContacts = [];
        _.each(contacts, contact => {
            poContacts.push({
                key: contact.id,
                text: `${contact.name} (${contact.email})`,
                value: _.toString(contact.id),
            });
        });
        return (
            <Form size="large">
                <Segment stacked>
                    <div className="row">
                        <div className="col-md-6">
                            {model.id ? <h3>{model.relations.company_name}</h3> : <RelationSearch
                                selectedValues={model.relation_id ? _.toString(model.relation_id) : "0"}
                                onValueChange={(e, data) => {this.onRelationSearchChange(e, data)}}
                                shouldAllowAll={false}
                                relationType={this.props.relationType}
                                jwt={this.props.jwt}
                                name={this.props.relationType}
                                placeHolder=''
                            />}
                        </div>
                        <div className="col-md-6">
                            <div style={{float: 'right'}}>
                                <Button
                                    color="teal"
                                    onClick={this.onFormSubmit}
                                    size="mini"
                                    loading={this.state.loading}
                                    disabled={!isDirty}
                                    floated='right'
                                >
                                    Save Change
                                </Button>
                            </div>
                        </div>
                    </div>
                </Segment>
                {model.relation_id ? <Segment stacked>
                {!_.isEmpty(this.state.errors) ? (
                    <FormErrorMessage errors={this.state.errors} />
                ) : null}
                <div className="row">
                    <div className="col-md-7">
                        <Form.Group unstackable widths={2}>
                            <Form.Select fluid 
                                label={routeType === 'vendor-orders' || routeType === 'customer-returns' ? 'Receive To Warehouse' : 'Ship From Warehouse'}
                            options={
                                _.isArray(warehouses) ? warehouses : []
                            } name="warehouse_id" value={model.warehouse_id ? _.toString(model.warehouse_id) : "0"} 
                                onChange={(e,data) => { updateOrderModelInStore('warehouse_id', data.value) }}
                            />
                            <Form.Input 
                                fluid 
                                label="Reference #"
                                name="reference"
                                value={model.reference ? model.reference : ""} 
                                onChange={(e) => { updateOrderModelInStore(e.target.name, e.target.value) }}
                            />
                        </Form.Group>
                        <Form.Group unstackable widths={2}>
                            <Form.Input 
                                fluid 
                                label={this.props.relationType === 'Vendor' ? 'Vendor PO #' : 'Customer PO #'}
                                name="po"
                                value={model.po ? model.po : ""} 
                                onChange={(e) => { updateOrderModelInStore(e.target.name, e.target.value) }}
                            />
                            <Form.Input 
                                type="date"
                                fluid 
                                label={this.props.relationType === 'Vendor' ? 'Planned Receive Date' : 'Planned Ship Date'}
                                name="ship_at"
                                value={model.ship_at ? model.ship_at : ""} 
                                onChange={(e) => { updateOrderModelInStore(e.target.name, e.target.value) }}
                            />
                        </Form.Group>
                        <Form.Group unstackable widths={2}>
                            <Form.Select fluid label='Contacts' options={poContacts} 
                            name="contact_id" value={model.contact_id ? _.toString(model.contact_id) : "0"} 
                                onChange={(e,data) => { updateOrderModelInStore('contact_id', data.value) }}
                            />
                            <Form.Select fluid label='Assign To' options={
                                _.isArray(users) ? users : []
                            } name="assigned_to" value={model.assigned_to ? _.toString(model.assigned_to) : "0"} 
                                onChange={(e,data) => { updateOrderModelInStore('assigned_to', data.value) }}
                            />
                            
                        </Form.Group>
                        <Form.Group unstackable widths={3}>
                            <Form.Select fluid label='Currency' options={
                            [
                                {key: 'CAD', value: 'CAD', text: 'CAD'},
                                {key: 'USD', value: 'USD', text: 'USD'},
                            ]
                            } name="currency" value={model.currency ? model.currency : 0} 
                                onChange={(e,data) => { updateOrderModelInStore('currency', data.value) }}
                            />
                            <Form.Select fluid label='Payment Term' options={
                                _.isArray(terms) ? terms : []
                            } name="term_id" value={model.term_id ? model.term_id : 0} 
                                onChange={(e,data) => { updateOrderModelInStore('term_id', data.value) }}
                            />
                            <Form.Select fluid label='Tax' options={
                                _.isArray(taxes) ? taxes : []
                            } name="tax_id" value={model.tax_id ? model.tax_id : 0} 
                                onChange={(e,data) => { updateOrderModelInStore('tax_id', data.value) }}
                            />
                            </Form.Group>
                    </div>
                    <div className="col-md-5">
                        <AddressSelector
                            name={routeType === 'vendor-orders' || routeType === 'customer-returns' ? 'Bill From' : `Bill To ${model.shopify_id ? "(Please do not modify shopify address, you can add a new address)" : null}`}
                            selectedValues={_.toString(model.bill_to)}
                            onValueChange={(e, data) => {this.onChildSelectorValueChange(e, data, 'bill_to')}}
                            addresses={addresses}
                            relationId={_.toString(model.relation_id)}
                        />
                        <div style={{marginTop: '1em'}}>
                            <AddressSelector
                                name={routeType === 'vendor-orders' || routeType === 'customer-returns' ? 'Ship From' : `Ship To ${model.shopify_id ? "(Please do not modify shopify address, you can add a new address)" : null}`}
                                selectedValues={_.toString(model.ship_to)}
                                onValueChange={(e, data) => {this.onChildSelectorValueChange(e, data, 'ship_to')}}
                                addresses={addresses}
                                relationId={_.toString(model.relation_id)}
                            />
                        </div>
                        <div className="row" style={{marginTop: '1em'}}>
                        <div className="col-md-12">
                            <label style={{
                                display: 'block',
                                margin: '0 0 .28571429rem 0',
                                color: 'rgba(0,0,0,.87)',
                                fontSize: '.92857143em',
                                fontWeight: 700,
                                textTransform: 'none'
                            }}>PO Note</label>
                            <TextArea value={model.notes ? model.notes : ""}
                                rows={4}
                                onChange={(e, data) => {updateOrderModelInStore('notes', data.value)}} />
                        </div>
                    </div>
                    </div>
                </div>
                </Segment> : null}

                {model.relation_id && model.warehouse_id ? <Segment stacked>
                    <div className="row">
                        <div className="col-md-12">
                            <InventorySearch
                                jwt={this.props.jwt}
                                onSelected={(inventory) => {this.onInventorySelected(inventory)}}
                                exceptIds={this.exceptedInventoryIds()}
                                requireInventoryPricing={true}
                                relationId={_.toString(model.relation_id)}
                            />
                        </div>
                        <div className="col-md-12">
                            <Table compact>
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell>SKU</Table.HeaderCell>
                                        <Table.HeaderCell>Name</Table.HeaderCell>
                                        <Table.HeaderCell>UPC</Table.HeaderCell>
                                        <Table.HeaderCell>UOM</Table.HeaderCell>
                                        <Table.HeaderCell>Price</Table.HeaderCell>
                                        <Table.HeaderCell>Quantity</Table.HeaderCell>
                                        <Table.HeaderCell>Stock</Table.HeaderCell>
                                        <Table.HeaderCell></Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body>
                                    {_.isArray(model.lines_view) ? model.lines_view.map(line => {
                                        return <OrderLineForm key={line.id} line={line} warehouseId={_.toString(model.warehouse_id)} />
                                    }): null}
                                </Table.Body>
                            </Table>
                        </div>
                        {model.id ? null : <div className="col-md-12" style={{marginTop: '15px'}}>
                            <Button
                                color="teal"
                                onClick={this.onFormSubmit}
                                size="medium"
                                loading={this.state.loading}
                                disabled={!isDirty}
                                floated='right'
                            >
                                Create New Order
                            </Button>
                        </div>}
                    </div>
                </Segment> : null}
            </Form>
        );
    }
}

OrderForm.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func.isRequired
    }).isRequired,
    createFullOrder: PropTypes.func.isRequired,
    updateOrderModelInStore: PropTypes.func.isRequired,
    updateCompleteOrder: PropTypes.func.isRequired,
    addLineToSavedModel: PropTypes.func.isRequired,
    model: PropTypes.object.isRequired,
    isDirty: PropTypes.bool.isRequired,
    jwt: PropTypes.string.isRequired,
    relationType: PropTypes.string.isRequired,
    user: PropTypes.object.isRequired,
    warehouses: PropTypes.array.isRequired,
    taxes: PropTypes.array.isRequired,
    terms: PropTypes.array.isRequired,
    users: PropTypes.array.isRequired,
    loadRelationById: PropTypes.func.isRequired,
    addresses: PropTypes.array.isRequired,
    contacts: PropTypes.array.isRequired,
    addLineToUnsavedModel: PropTypes.func.isRequired,
    routeType: PropTypes.string.isRequired
};

function mapStateToProps(state) {
    return {
        model: state.order.model,
        isDirty: state.order.dirty,
        jwt: state.auth.jwt,
        user: state.auth.user,
        warehouses: state.system.resources.warehouses,
        taxes: state.system.resources.taxes,
        terms: state.system.resources.terms,
        users: state.system.resources.users,
        addresses: state.relation.model.addresses,
        contacts: state.relation.model.contacts
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            createFullOrder,
            updateOrderModelInStore,
            loadRelationById,
            addLineToUnsavedModel,
            addLineToSavedModel,
            updateCompleteOrder
        },
        dispatch
    );
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(OrderForm);



// WEBPACK FOOTER //
// ./src/components/forms/orders/Order.js